import { render, staticRenderFns } from "./SchemaInputCopyPickerModal.vue?vue&type=template&id=5cb1519a&scoped=true&"
import script from "./SchemaInputCopyPickerModal.vue?vue&type=script&lang=js&"
export * from "./SchemaInputCopyPickerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1519a",
  null
  
)

export default component.exports